import { Col, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Select, Text, TextField } from "../../components";
import {
  MontserratBold,
  MontserratMedium,
  MontserratRegular,
  PoppinsMedium,
} from "../../config/fonts";
import { Colors, Fonts, Images, Utils } from "../../config";
import { CloseCircleOutlined, InboxOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import Basic from "../../components/Text/basic";
import { useDispatch, useSelector } from "react-redux";
import { AdsAction } from "../../store/actions";
// import * as Icon from "react-icons/all";
import { MdClose } from "react-icons/md";

const EditAds = ({ closeModal, data }) => {
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const ad = useSelector((state) => state.ads);

  const props = {
    name: "file",
    multiple: true,
    action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        // message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        // message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const [state, setState] = useState({
    // link: "",
    endDate: "",
    file: null,
  });

  const [error, setError] = useState({
    // linkError: "",
    endDateError: "",
    fileError: "",
  });

  const handleFileChange = (info) => {
    console.log(info?.file?.originFileObj);
    setState({
      ...state,
      file: info?.file?.originFileObj,
    });
    setError({
      ...error,
      fileError: "",
    });
    setFile(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // if (!state.link) {
    //     setError({ ...error, linkError: "Field can't be empty" })
    // }
    if (!state.endDate) {
      setError({ ...error, endDateError: "Field can't be empty" });
    } else if (!state.file && !file) {
      setError({ ...error, fileError: "Field can't be empty" });
    } else {
      let apiData = {
        id: data?.id,
        end_date: state?.endDate,
        file: state?.file,
      };
      dispatch(
        AdsAction.editAds(apiData, (res) => {
          closeModal();
          handleReset();
          dispatch(
            AdsAction.getAdsListing({
              limit: 10,
              offset: 0,
              keyword: "",
              status: "",
            })
          );
        })
      );
    }
  };

  const handleChange = (e) => {
    if (e.target.name == "endDate") {
      let input = e.target.value;

      // Only allow digits and dash (-)
      input = input.replace(/[^0-9]/g, "");

      // Automatically format as YYYY-MM-DD
      if (input.length <= 4) {
        input = input;
      } else if (input.length <= 6) {
        input = `${input.slice(0, 4)}-${input.slice(4)}`;
      } else {
        input = `${input.slice(0, 4)}-${input.slice(4, 6)}-${input.slice(
          6,
          8
        )}`;
      }

      setState({
        ...state,
        endDate: input,
      });
    } else {
      setState({
        ...state,
        [e.target.name]: e.target.value,
      });
    }

    setError({
      ...error,
      [e.target.name + "Error"]: "",
    });
  };

  const handleReset = () => {
    setError({
      // linkError: "",
      endDateError: "",
      fileError: "",
    });

    setState({
      // link: "",
      endDate: "",
      file: null,
    });

    setFile(null);
  };

  useEffect(() => {
    if (data) {
      setState({
        // link: data?.link,
        endDate: data?.end_date,
      });

      setFile(data?.file);
    }
  }, [data]);

  return (
    <div className="edit-ad-modal">
      <Row justify={"space-between"} className="mb-20">
        <Col>
          <Text.Basic
            color={Colors.Black}
            fontSize={22}
            fontWeight={600}
            fontFamily={Fonts[MontserratBold]}
            text={"Edit Ad"}
            textAlign="left"
          />
        </Col>
        <Col>
          <MdClose
            color={Colors.Black}
            fontSize={24}
            cursor={"pointer"}
            onClick={closeModal}
          />
        </Col>
      </Row>

      <Row gutter={[25, 25]} className="mb-20">
        {/* <Col span={24}>
                    <TextField.Basic
                        label="Link *"
                        labelFontWeight={600}
                        labelFontFamily={Fonts[MontserratMedium]}
                        size={"large"}
                        placeholder="Link *"
                        value={state.link}
                        onChange={handleChange}
                        name="link"
                        errorText={error.linkError && error.linkError}
                    />
                </Col> */}

        <Col span={24}>
          <TextField.Basic
            label="End Date *"
            labelFontWeight={600}
            labelFontFamily={Fonts[MontserratMedium]}
            size={"large"}
            placeholder="End Date *"
            value={state.endDate}
            name="endDate"
            onChange={handleChange}
            errorText={error.endDateError && error.endDateError}
          />
        </Col>

        <Col span={24}>
          <Text.Basic
            fontSize={18}
            fontWeight={600}
            fontFamily={Fonts[MontserratBold]}
            text={"File *"}
            textAlign="left"
          />

          <Dragger
            {...props}
            onChange={handleFileChange}
            onDrop={handleFileChange}
            multiple={false}
            className="mt-10"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
          </Dragger>
          {file && (
            <div className="mt-10 flex-row-space-between flex-row-align-center">
              <p className="m-0">{file}</p>
              <span onClick={() => setFile(null)}>
                <CloseCircleOutlined />
              </span>
            </div>
          )}
          {error.fileError && <Text.Error text={error.fileError} />}
        </Col>

        <Col span={24}>
          <Button.Basic
            size={"large"}
            buttonStyle={{
              backgroundColor: Colors.BlueText,
              color: Colors.White,
              width: "100%",
              height: "50px",
              fontSize: "16px",
              fontFamily: Fonts[PoppinsMedium],
              borderRadius: "10px",
              border: "none",
            }}
            loading={ad?.editAdsLoader}
            disabled={ad?.editAdsLoader}
            text={"Update"}
            onClick={handleSubmit}
          />
        </Col>
      </Row>
    </div>
  );
};

export default EditAds;
